import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.trim.js";
export default {
  data: function data() {
    return {
      searchForm: {
        ps: 20,
        pn: 1,
        isOpen: 1
      },
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 表单
      form: {
        img: "",
        enCityName: "",
        chCityName: "",
        twCityName: "",
        digest: "",
        spell: "",
        authCost: "",
        // 认证费
        realAuthCost: "",
        // 实名费
        serviceCost: "",
        //服务费
        cityMasterStartingPrice: "",
        code: ""
      },
      dialogVisible: false,
      // 弹窗状态
      isHot: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    //切换草稿
    updateDraft: function updateDraft(row) {
      var _this2 = this;
      this.$confirm("".concat(this.searchForm.isOpen == 0 ? "转为草稿" : "转为待开放", "\uFF0C \u662F\u5426\u7EE7\u7EED?"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.updateCityDraft({
                id: row.id,
                isDraft: row.isDraft == 1 ? 0 : 1
              });
            case 1:
              res = _context2.v;
              _this2.$message.success("操作成功");
              //如果设为待开放修改操作，重置 前端城市列表缓存
              _this2.$api.updateFrontendCityList();
              _this2.getData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      })));
    },
    // 更新排序
    updateSort: function updateSort(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.updateCityOrder({
                id: row.id,
                order: row.order
              });
            case 1:
              _this3.$message.success("操作成功");
              _this3.getData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    // 开放 | 关闭 城市
    updateCityStatus: function updateCityStatus(row) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this4.$confirm("".concat(row.isOpen == 1 ? "关闭" : "开放", "\u57CE\u5E02\uFF0C \u662F\u5426\u7EE7\u7EED?"), "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                var res;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      _context4.n = 1;
                      return _this4.$api.updateCityStatus({
                        id: row.id,
                        isOpen: row.isOpen == 1 ? 0 : 1
                      });
                    case 1:
                      res = _context4.v;
                      _this4.$message.success("操作成功");
                      //如果开放关闭城市，重置 前端城市列表缓存
                      _this4.$api.updateFrontendCityList();
                      _this4.getData();
                    case 2:
                      return _context4.a(2);
                  }
                }, _callee4);
              })));
            case 1:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var param, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (type === "search") {
                _this5.searchForm.pn = 1;
              }
              _this5.tableLoading = true;
              param = JSON.parse(JSON.stringify(_this5.searchForm));
              if (param.isOpen == 3) {
                param.isDraft = 1;
                param.isOpen = 0;
              }
              _context6.n = 1;
              return _this5.$api.getCityList(param);
            case 1:
              res = _context6.v;
              _this5.tableData = res.data.list;
              _this5.total = res.data.count;
              _this5.tableLoading = false;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.isHot = this.form.isHot || 0;
      this.dialogVisible = true;
    },
    save: function save() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              res = null;
              _this6.form.code = _this6.form.code.trim();
              if (!_this6.form.id) {
                _context7.n = 2;
                break;
              }
              _context7.n = 1;
              return _this6.$api.updateCity(_this6.form);
            case 1:
              res = _context7.v;
              _context7.n = 4;
              break;
            case 2:
              _context7.n = 3;
              return _this6.$api.addCity(_this6.form);
            case 3:
              res = _context7.v;
            case 4:
              _this6.dialogVisible = false;
              //如果开放城市设置为热门城市更新热门城市数据
              if (_this6.form.isHot === 1 || _this6.isHot === 1) {
                _this6.$api.clearHotListCache();
              }
              _this6.form = {};
              _this6.isHot = 0;
              _this6.getData();
            case 5:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    }
  }
};